import { z } from "zod";

import { AgreementMiscChargeItem } from "../agreement/agreementData";
import { RentalRateListItemSchema } from "../rate";

export type ReservationDataParsed = z.infer<typeof ReservationDataSchema>;
export const ReservationDataSchema = z.object({
  reservationview: z.object({
    reserveId: z.number(),
    additionalCharge: z.number().nullable(),
    reservationNumber: z.string().nullable(),
    reservationType: z.string().nullable(),
    owningLocationId: z.coerce.string().nullable(),
    lowestRate: z.any(),
    // clientId: 681,
    customerId: z.coerce.string().nullable(),
    vehicleId: z.coerce.string().nullable(),
    vehicleMakeName: z.string().nullable(),
    trim: z.string().nullable(),
    year: z.number().nullable(),
    startDate: z.string().nullable(),
    endDate: z.string().nullable(),
    createdDate: z.string().nullable(),
    notes: z.string().nullable(),
    licenseNo: z.string().nullable(),
    vehicleNo: z.string().nullable(),
    fuelType: z.string().nullable(),
    fuelLevel: z.string().nullable(),
    transmission: z.string().nullable(),
    currentOdometer: z.number().nullable(),
    color: z.coerce.string().nullable(),
    doors: z.coerce.string().nullable(),
    vin: z.string().nullable(),
    statusId: z.number().nullable(),
    insuranceAmt: z.number().nullable(),
    startLocationId: z.number().nullable(),
    startLocationName: z.string().nullable(),
    startLocationAddress1: z.string().nullable(),
    startLocationAddress2: z.string().nullable(),
    startLocationCity: z.string().nullable(),
    startLocationPhone: z.string().nullable(),
    startLocationCountryName: z.string().nullable(),
    startLocationStateName: z.string().nullable(),
    endLocationId: z.number().nullable(),
    endLocationName: z.string().nullable(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    address1: z.string().nullable(),
    address2: z.string().nullable(),
    city: z.string().nullable(),
    stateCode: z.string().nullable(),
    productionName: z.string().nullable(),
    countryName: z.string().nullable(),
    zipCode: z.string().nullable(),
    dateOfBirth: z.string().nullable(),
    customerType: z.string(),
    phone: z.string().nullable(),
    hPhone: z.string().nullable(),
    bPhone: z.string().nullable(),
    cPhone: z.string().nullable(),
    email: z.string().nullable(),
    company: z.string().nullable(),
    vehicleTypeId: z.number().nullable(),
    vehicleType: z.string().nullable(),
    modelId: z.number().nullable(),
    modelName: z.string().nullable(),
    canceledDate: z.string().nullable(),
    basePrice: z.number().default(0).nullable(),
    note: z.string().nullable(),
    agreementId: z.number().nullable(),
    agreementNumber: z.string().nullable(),
    cancellationCharge: z.number().nullable(),
    advancedPayment: z.number().nullable(),
    creditCardExpiryDate: z.string().nullable(),
    creditCardNo: z.string().nullable(),
    creditCardType: z.string().nullable(),
    creditCardCVSNo: z.string().nullable(),
    ldw: z.number().default(0).nullable(),
    tldw: z.number().default(0).nullable(),
    specialNote: z.string().nullable(),
    promotionId: z.number().nullable(),
    deposit: z.number().default(0).nullable(),
    logId: z.number().default(0).nullable(),
    creditCardBillingZipCode: z.string().nullable(),
    imageName: z.string().nullable(),
    totalDays: z.number(),
    isCompound: z.boolean(),
    fullDepositAmount: z.number().default(0).nullable(),
    installmentAmount: z.number().default(0).nullable(),
    perInstallmentAmount: z.number().default(0).nullable(),
    installmentQty: z.number().default(0).nullable(),
    preAdjustment: z.number().default(0).nullable(),
    reservationPrimaryId: z.number().nullable(),
    prep: z.boolean(),
    wrap: z.boolean(),
    vehicleTypeId2: z.coerce.string().nullable(),
    vehicleId2: z.coerce.string().nullable(),
    vehicleMakeName2: z.string().nullable(),
    modelName2: z.string().nullable(),
    year2: z.number().nullable(),
    licenseNo2: z.string().nullable(),
    vehicleNo2: z.string().nullable(),
    vehicleType2: z.coerce.string().nullable(),
    poNo: z.string().nullable(),
    roNo: z.string().nullable(),
    poNo2: z.string().nullable(),
    roNo2: z.string().nullable(),
    totalDiscount: z.number().nullable(),
    locationId: z.number().nullable(),
    daysInWeek: z.number(),
    createdBy: z.string().nullable(),
    lastUpdateByName: z.string().nullable(),
    reservationStatus: z.number(),
    isRetrieval: z.boolean(),
    isDelivery: z.boolean(),
    projectedMileage: z.number().nullable(),
    referralId: z.coerce.string().nullable(),
    voucherNo: z.string().nullable(),
    locationEmail: z.string().nullable(),
    locationEmailName: z.string().nullable(),
    referralCommission: z.number(),
    total: z.number().nullable(),
    totalRows: z.number().nullable(),
    createdById: z.number(),
    billingStartDate: z.string().nullable(),
    billingEndDate: z.string().nullable(),
    reservationStatusName: z.string(),
    creditCardNoView: z.any(),
    paymentMethodForAdvancepaymnts: z.string().nullable(),
    paymentMethodForCancellationchrgs: z.string().nullable(),
    depositAmount: z.number().nullable(),
    depositPaymentType: z.string().nullable(),
    depositMethod: z.string().nullable(),
    checkoutState: z.coerce.string().nullable(),
    checkinstate: z.coerce.string().nullable(),
    isOnline: z.boolean(),
    unTaxableAdditional: z.number().nullable(),
    destination: z.string().nullable(),
    extraCheckOutLocation: z.string().nullable(),
    extraCheckInLocation: z.string().nullable(),
    refferalName: z.string().nullable(),
    referralCalculationType: z.number().nullable(),
  }),

  miscChargeList: z.array(AgreementMiscChargeItem).nullable(),

  taxList: z.array(
    z.object({
      agreementID: z.number().nullable(),
      taxId: z.number().nullable(),
      name: z.string().nullable(),
      description: z.string().nullable(),
      value: z.number(),
      isOption: z.boolean(),
      isSelected: z.boolean(),
      locationId: z.number().nullable(),
      taxValue: z.number().nullable(),
      locationName: z.string().nullable(),
      locationTaxID: z.number().nullable(),
      createdBy: z.number().nullable(),
      createdByName: z.string().nullable(),
      lastUpdatedByName: z.string().nullable(),
      activeDate: z.string().nullable(),
      expiryDate: z.string().nullable(),
      activeDatestr: z.string().nullable(),
      expiryDatestr: z.string().nullable(),
      taxSelectedStatus: z.any(),
      glCode: z.string().nullable(),
    })
  ),

  rateList: z.array(RentalRateListItemSchema),

  reservationTotal: z.number().nullable(),
  reservationAttributeList: z.array(z.any()),

  paymentList: z.array(
    z.object({
      agreementNo: z.string().nullable(),
      paymentDateStr: z.string().nullable(),
      paymentMethodId: z.number().nullable(),
      poNumber: z.string().nullable(),
      totalPayable: z.number().nullable(),
      balanceDue: z.number().nullable(),
      availableDriverDeposit: z.any(),
      startDate: z.string().nullable(),
      endDate: z.string().nullable(),
      isPaymentSchedule: z.boolean(),
      subAgreementId: z.number().nullable(),
      invoiceIds: z.any(),
      creditNotes: z.any(),
      negativeList: z.any(),
      amountPaid: z.number().nullable(),
      totalBalanceDue: z.number().nullable(),
      payreason: z.number().nullable(),
      amountToPay: z.number().nullable(),
      paymentId: z.number().nullable(),
      paymentNumber: z.string().nullable(),
      referenceType: z.number().nullable(),
      referenceId: z.number().nullable(),
      agreementId: z.number().nullable(),
      primaryAgreementId: z.number().nullable(),
      reservationId: z.number().nullable(),
      editAvailable: z.boolean(),
      deleteAvailable: z.boolean(),
      amount: z.number().nullable(),
      description: z.string().nullable(),
      paymentDate: z.string().nullable(),
      paymentMethod: z.string().nullable(),
      invoiceId: z.number().nullable(),
      lastUpdatedBy: z.number().nullable(),
      lastUpdatedDate: z.string().nullable(),
      mode: z.string().nullable(),
      paymentType: z.string().nullable(),
      referenceNo: z.string().nullable(),
      paymentBy: z.string().nullable(),
      paymentLogId: z.coerce.string().nullable(),
      transcationId: z.coerce.string().nullable(),
      createdByName: z.coerce.string().nullable(),
      lastUpdatedByName: z.coerce.string().nullable(),
      status: z.coerce.string().nullable(),
      id: z.coerce.string().nullable(),
      card_details: z.any(),
      paymentFor: z.coerce.string().nullable(),
    })
  ),
  //   {
  //     agreementNo: null,
  //     paymentDateStr: "0001-01-01T00:00:00",
  //     paymentMethodId: 0,
  //     poNumber: null,
  //     totalPayable: null,
  //     balanceDue: null,
  //     availableDriverDeposit: null,
  //     startDate: null,
  //     endDate: null,
  //     isPaymentSchedule: false,
  //     subAgreementId: 0,
  //     invoiceIds: null,
  //     creditNotes: null,
  //     negativeList: null,
  //     amountPaid: null,
  //     totalBalanceDue: null,
  //     payreason: 0,
  //     amountToPay: null,
  //     paymentId: 160069,
  //     paymentNumber: "5",
  //     referenceType: 0,
  //     referenceId: 0,
  //     agreementId: 0,
  //     primaryAgreementId: 0,
  //     reservationId: 118254,
  //     editAvailable: false,
  //     deleteAvailable: false,
  //     amount: 17.75,
  //     description: "Advance Paid",
  //     paymentDate: "2022-11-05T15:21:54.03",
  //     paymentMethod: "CreditCard",
  //     invoiceId: null,
  //     lastUpdatedBy: null,
  //     lastUpdatedDate: null,
  //     mode: "Payment",
  //     paymentType: "Advance Payment",
  //     referenceNo: "ch_3M0rwDLS634rcKKw0Fv8s5Jj",
  //     paymentBy: null,
  //     paymentLogId: null,
  //     transcationId: null,
  //     createdByName: "Testss Admin - client 1",
  //     lastUpdatedByName: "Michael Flanigan",
  //     status: null,
  //     id: null,
  //     card_details: null,
  //     paymentFor: 0,
  //   },
  // ],

  clientPdfTemplatesList: z.array(z.any()),

  emailTrackList: z.array(z.any()),
  depositTotals: z
    .object({
      depositAmount: z.number(),
      onHoldAmount: z.number(),
      refundAmount: z.number(),
      releaseAmount: z.number(),
      forfeitureAmount: z.number(),
      totalCanceledAmount: z.number(),
      balanceDeposit: z.number(),
    })
    .nullable(),
  invoiceList: z.any(),

  reservtionBillingReview: z.any(),

  reservationBillingList: z.array(
    z.object({
      billingInfoID: z.number().optional(),
      reservationID: z.number(),
      contactName: z.string().nullable(),
      contactAddress: z.string().nullable(),
      contactPhone: z.string().nullable(),
      contactEmail: z.string().nullable(),
      isActive: z.boolean(),
      billingBy: z.string().nullable(),
      billingOwnerId: z.number().nullable(),
    })
  ),
  mileageCharges: z.array(z.any()),

  agreementReservationMileageBreakdown: z.array(z.any()),

  navDynamicAttribute: z.any(),
  agreementInsurance: z.any(),

  customerImages: z.array(z.any()),
  referral: z.any(),

  driverList: z.array(z.any()),

  customerDetails: z.object({
    customerId: z.number(),
    customerNumber: z.string().nullable(),
    companyName: z.string().nullable(),
    firstName: z.string().nullable(),
    middleName: z.string().nullable(),
    lastName: z.string().nullable(),
    dateOfbirth: z.string().nullable(),
    address1: z.string().nullable(),
    address2: z.string().nullable(),
    zipCode: z.string().nullable(),
    city: z.string().nullable(),
    stateId: z.number().nullable(),
    countryId: z.number().nullable(),
    hPhone: z.string().nullable(),
    bPhone: z.string().nullable(),
    cPhone: z.string().nullable(),
    fax: z.string().nullable(),
    licenseNumber: z.string().nullable(),
    licenseCategory: z.string().nullable(),
    email: z.string().nullable(),
    hstNumber: z.string().nullable(),
    active: z.boolean(),
    countryName: z.string().nullable(),
    stateName: z.string().nullable(),
    stateCode: z.string().nullable(),
    insuranceCompany: z.string().nullable(),
    policyNumber: z.string().nullable(),
    insuranceExpiryDate: z.string().nullable(),
    insuranceCountry: z.coerce.string().nullable(),
    insuranceProvince: z.coerce.string().nullable(),
    creditCardType: z.string().nullable(),
    creditCardNo: z.string().nullable(),
    creditCardExpiryDate: z.string().nullable(),
    creditCardCVSNo: z.string().nullable(),
    insuranceState: z.string().nullable(),
    billingAddress1: z.string().nullable(),
    billingCity: z.string().nullable(),
    billingZipCord: z.any(),
    insuranceClaim: z.any(),
    billStateName: z.string().nullable(),
    billingStateId: z.coerce.string().nullable(),
    billingCountyId: z.coerce.string().nullable(),
    customerType: z.string().nullable(),
    billCountryName: z.string().nullable(),
    password: z.string().nullable(),
    licenseIssueDate: z.string().nullable(),
    licenseExpiryDate: z.string().nullable(),
    licenseIssueState: z.string().nullable(),
    passportNo: z.string().nullable(),
    passportIssueDate: z.string().nullable(),
    passportExpairyDate: z.string().nullable(),
    locationId: z.number().nullable(),
    locationName: z.string().nullable(),
    creditCardBillingZipCode: z.string().nullable(),
    rateName: z.string().nullable(),
    productionName: z.string().nullable(),
    nameOnCard: z.string().nullable(),
    customerImage: z.string().nullable(),
    drivingExperience: z.string().nullable(),
    isBlackListed: z.boolean(),
    blackListId: z.number(),
    blackListDescription: z.string().nullable(),
    blackListDate: z.string().nullable(),
    blackListReason: z.number(),
    licenseCountryId: z.number().nullable(),
    accoutNameInBank: z.string().nullable(),
    accountNumber: z.string().nullable(),
    bsb: z.any(),
    emergencyContactNo: z.string().nullable(),
    companyRegNo: z.string().nullable(),
    isSMSOpted: z.boolean(),
    isEmailOpted: z.boolean(),
    qboReferenceId: z.coerce.string().nullable(),
    ticketFlag: z.number().nullable(),
    createdBy: z.number().nullable(),
    userName: z.string().nullable(),
    totalRows: z.number(),
    rowNum: z.number(),
    paymentTerms: z.number().nullable(),
    isTaxExempt: z.boolean(),
    licenseCountryName: z.string().nullable(),
    bankName: z.string().nullable(),
    bankSwiftCode: z.string().nullable(),
    createdByName: z.string().nullable(),
    lastUpdatedBy: z.number().nullable(),
    phone: z.string().nullable(),
    lastUpdatedByName: z.string().nullable(),
    insuranceCountryName: z.string().nullable(),
    insuranceProvinceName: z.string().nullable(),
    locationIds: z.any(),
    countryCode: z.string().nullable(),
    licenseStateCode: z.string().nullable(),
    dmsid: z.any().nullable(),
    insuranceCompanyName: z.string().nullable(),
    insuranceCompanyAddress: z.string().nullable(),
    insuranceContactPhone: z.string().nullable(),
    insuranceContactEmail: z.string().nullable(),
    customerImageList: z.array(z.any()).nullable(),
    employmentType: z.string().nullable(),
    brokerName: z.string().nullable(),
    brokerAddress: z.string().nullable(),
    brokerPhone: z.string().nullable(),
    brokerEmail: z.string().nullable(),
  }),

  promotionList: z.array(z.any()),
  deductibleMiscCharge: z.array(z.any()),
});
